import { useTranslation } from 'react-i18next';
import { Save } from 'lucide-react';

import { ActionButton } from '@/shared/ui/action-button';

interface SaveButtonProps {
  onClick: (formData?: unknown) => void | Promise<void>;
  isLoading?: boolean;
  isReadOnly?: boolean;
}

export function SaveButton({ onClick, isLoading = false, isReadOnly = false }: SaveButtonProps) {
  const { t } = useTranslation();

  if (isReadOnly) {
    return null;
  }

  return (
    <ActionButton intent="primary" onClick={onClick} size="sm" className="grow sm:grow-0" disabled={isLoading}>
      <Save className="h-4 w-4 mr-2" />
      {t('newcmr.save.label', 'Save Changes')}
    </ActionButton>
  );
}
